// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrDetailsRequestDto } from './IOcrDetailsRequestDto';
import {
    IOcrDetailsRequestDtoFromJSON,
    IOcrDetailsRequestDtoFromJSONTyped,
    IOcrDetailsRequestDtoToJSON,
    IOcrDetailsRequestDtoToJSONTyped,
} from './IOcrDetailsRequestDto';
import type { IAccountOrderMatrixDto } from './IAccountOrderMatrixDto';
import {
    IAccountOrderMatrixDtoFromJSON,
    IAccountOrderMatrixDtoFromJSONTyped,
    IAccountOrderMatrixDtoToJSON,
    IAccountOrderMatrixDtoToJSONTyped,
} from './IAccountOrderMatrixDto';
import type { IAccountOrderDto } from './IAccountOrderDto';
import {
    IAccountOrderDtoFromJSON,
    IAccountOrderDtoFromJSONTyped,
    IAccountOrderDtoToJSON,
    IAccountOrderDtoToJSONTyped,
} from './IAccountOrderDto';

/**
 * 
 * @export
 * @interface IOcrDto
 */
export interface IOcrDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrDto
     */
    confidence?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrDto
     */
    employee_full_name?: string;
    /**
     * 
     * @type {Array<Array<IAccountOrderDto>>}
     * @memberof IOcrDto
     */
    account_orders?: Array<Array<IAccountOrderDto>>;
    /**
     * 
     * @type {Array<IAccountOrderMatrixDto>}
     * @memberof IOcrDto
     */
    account_orders_matrixes?: Array<IAccountOrderMatrixDto>;
    /**
     * 
     * @type {IOcrDetailsRequestDto}
     * @memberof IOcrDto
     */
    ocr_details_request?: IOcrDetailsRequestDto;
    /**
     * 
     * @type {string}
     * @memberof IOcrDto
     */
    claim_payment_type?: IOcrDtoClaimPaymentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrDto
     */
    is_sigis_auto_approve_enabled?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IOcrDtoClaimPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}


/**
 * Check if a given object implements the IOcrDto interface.
 */
export function instanceOfIOcrDto(value: object): value is IOcrDto {
    return true;
}

export function IOcrDtoFromJSON(json: any): IOcrDto {
    return IOcrDtoFromJSONTyped(json, false);
}

export function IOcrDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrDto {
    if (json == null) {
        return json;
    }
    return {
        
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'employee_full_name': json['employee_full_name'] == null ? undefined : json['employee_full_name'],
        'account_orders': json['account_orders'] == null ? undefined : json['account_orders'],
        'account_orders_matrixes': json['account_orders_matrixes'] == null ? undefined : ((json['account_orders_matrixes'] as Array<any>).map(IAccountOrderMatrixDtoFromJSON)),
        'ocr_details_request': json['ocr_details_request'] == null ? undefined : IOcrDetailsRequestDtoFromJSON(json['ocr_details_request']),
        'claim_payment_type': json['claim_payment_type'] == null ? undefined : json['claim_payment_type'],
        'is_sigis_auto_approve_enabled': json['is_sigis_auto_approve_enabled'] == null ? undefined : json['is_sigis_auto_approve_enabled'],
    };
}

export function IOcrDtoToJSON(json: any): IOcrDto {
    return IOcrDtoToJSONTyped(json, false);
}

export function IOcrDtoToJSONTyped(value?: IOcrDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confidence': value['confidence'],
        'employee_full_name': value['employee_full_name'],
        'account_orders': value['account_orders'],
        'account_orders_matrixes': value['account_orders_matrixes'] == null ? undefined : ((value['account_orders_matrixes'] as Array<any>).map(IAccountOrderMatrixDtoToJSON)),
        'ocr_details_request': IOcrDetailsRequestDtoToJSON(value['ocr_details_request']),
        'claim_payment_type': value['claim_payment_type'],
        'is_sigis_auto_approve_enabled': value['is_sigis_auto_approve_enabled'],
    };
}

